/**
 * @generated SignedSource<<267e8059aaf8d6756e70d222729ec5cb>>
 * @relayHash 5ee43e31eecac9b5d24dd49658ef05ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9502539eeb67a07babc7cba937cd10a688026868eeffd959fe0af3e79ac100d0

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type AssociateProjectToFieldSchemeModalQuery$variables = {
  cloudId: string;
  projectAri: string;
};
export type AssociateProjectToFieldSchemeModalQuery$data = {
  readonly jira_doesTenantHaveNonNfaProjects: boolean | null;
  readonly jira_isTenantConvertedToNfa: boolean | null;
  readonly project: {
    readonly associatedFieldConfigScheme?: {
      readonly name: string | null;
      readonly schemeId: string | null;
    } | null;
    readonly associatedFieldScheme?: {
      readonly name: string | null;
      readonly schemeId: string | null;
    } | null;
    readonly key?: string;
    readonly name?: string;
    readonly projectId?: string | null;
    readonly projectType?: JiraProjectType | null;
    readonly " $fragmentSpreads": FragmentRefs<"AssociateProjectToFieldSchemeModal" | "AssociateProjectToFieldSchemeModal_legacySchemes">;
  } | null;
};
export type AssociateProjectToFieldSchemeModalQuery$rawResponse = {
  readonly jira_doesTenantHaveNonNfaProjects: boolean | null;
  readonly jira_isTenantConvertedToNfa: boolean | null;
  readonly project: {
    readonly __typename: "JiraProject";
    readonly associatedFieldConfigScheme: {
      readonly id: string;
      readonly name: string | null;
      readonly schemeId: string | null;
    } | null;
    readonly associatedFieldScheme: {
      readonly id: string;
      readonly name: string | null;
      readonly schemeId: string | null;
    } | null;
    readonly availableFieldConfigSchemes: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly __typename: "JiraFieldConfigScheme";
          readonly id: string;
          readonly name: string | null;
          readonly schemeId: string | null;
        } | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      };
    } | null;
    readonly availableFieldSchemes: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly __typename: "JiraFieldScheme";
          readonly id: string;
          readonly name: string | null;
          readonly schemeId: string | null;
        } | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      };
    } | null;
    readonly id: string;
    readonly key: string;
    readonly name: string;
    readonly projectId: string | null;
    readonly projectType: JiraProjectType | null;
  } | {
    readonly __typename: string;
    readonly id: string;
  } | null;
};
export type AssociateProjectToFieldSchemeModalQuery = {
  rawResponse: AssociateProjectToFieldSchemeModalQuery$rawResponse;
  response: AssociateProjectToFieldSchemeModalQuery$data;
  variables: AssociateProjectToFieldSchemeModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = {
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "jira_isTenantConvertedToNfa"
},
v4 = {
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "jira_doesTenantHaveNonNfaProjects"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v10 = {
  "kind": "ScalarField",
  "name": "schemeId"
},
v11 = [
  (v10/*: any*/),
  (v7/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = [
  (v10/*: any*/),
  (v7/*: any*/),
  (v13/*: any*/)
],
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  }
],
v16 = [
  (v10/*: any*/),
  (v7/*: any*/),
  (v13/*: any*/),
  (v12/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v18 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v19 = [
  "input"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AssociateProjectToFieldSchemeModalQuery",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": "project",
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "concreteType": "JiraFieldConfigScheme",
                "kind": "LinkedField",
                "name": "associatedFieldConfigScheme",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              {
                "concreteType": "JiraFieldScheme",
                "kind": "LinkedField",
                "name": "associatedFieldScheme",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              {
                "kind": "FragmentSpread",
                "name": "AssociateProjectToFieldSchemeModal"
              },
              {
                "kind": "FragmentSpread",
                "name": "AssociateProjectToFieldSchemeModal_legacySchemes"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssociateProjectToFieldSchemeModalQuery",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": "project",
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "concreteType": "JiraFieldConfigScheme",
                "kind": "LinkedField",
                "name": "associatedFieldConfigScheme",
                "plural": false,
                "selections": (v14/*: any*/)
              },
              {
                "concreteType": "JiraFieldScheme",
                "kind": "LinkedField",
                "name": "associatedFieldScheme",
                "plural": false,
                "selections": (v14/*: any*/)
              },
              {
                "args": (v15/*: any*/),
                "concreteType": "JiraFieldSchemesConnection",
                "kind": "LinkedField",
                "name": "availableFieldSchemes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldSchemesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldScheme",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v18/*: any*/)
                ],
                "storageKey": "availableFieldSchemes(first:40)"
              },
              {
                "args": (v15/*: any*/),
                "filters": (v19/*: any*/),
                "handle": "connection",
                "key": "AssociateProjectToFieldSchemeModal_adminPagesFieldSchemes__availableFieldSchemes",
                "kind": "LinkedHandle",
                "name": "availableFieldSchemes"
              },
              {
                "args": (v15/*: any*/),
                "concreteType": "JiraFieldConfigSchemesConnection",
                "kind": "LinkedField",
                "name": "availableFieldConfigSchemes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldConfigSchemesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldConfigScheme",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v16/*: any*/)
                      },
                      (v17/*: any*/)
                    ]
                  },
                  (v18/*: any*/)
                ],
                "storageKey": "availableFieldConfigSchemes(first:40)"
              },
              {
                "args": (v15/*: any*/),
                "filters": (v19/*: any*/),
                "handle": "connection",
                "key": "AssociateProjectToFieldSchemeModal_adminPagesFieldSchemes__availableFieldConfigSchemes",
                "kind": "LinkedHandle",
                "name": "availableFieldConfigSchemes"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9502539eeb67a07babc7cba937cd10a688026868eeffd959fe0af3e79ac100d0",
    "metadata": {},
    "name": "AssociateProjectToFieldSchemeModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d96a1b012aedf621dcec04a7f8eda804";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
